// 結果頁寫 correcting-log 的去重鍵（kanban 1003917）。
//
// 結果頁每打開一次就寫一筆批改紀錄到 correcting-log；同一篇作文重開結果頁，
// 儀表板上就多一筆重複的紀錄。correcting-log API 收到帶值的 correctionId 時，
// 以它 upsert（$setOnInsert）：第一筆贏、之後同鍵的整筆忽略；不帶就照舊新增一筆。
//
// 鍵的格式沿用 2026-06 歷史回填腳本的 `hs-backfill-<紀錄 _id>`：
// 同一篇作文不論是回填、還是結果頁即時寫入，都對到同一把鍵，兩條路徑不會各留一筆。
// 名字有 backfill，但即時寫入也用這個前綴，不要改成別的。
//
// 取不到 _id（workflowResult 空的、不是 JSON、沒有 _id…）就回 undefined、不 throw；
// 呼叫端照舊不帶 correctionId，行為與加這把鍵之前相同。

const CORRECTION_LOG_KEY_PREFIX = "hs-backfill-";

/** 從 sessionStorage 的 workflowResult（JSON 字串）取後台紀錄 _id，組成 correcting-log 的 correctionId。 */
export const correctionLogKey = (workflowResultString: string): string | undefined => {
  let parsed: unknown;
  try {
    parsed = JSON.parse(workflowResultString);
  } catch {
    return undefined;
  }
  if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) return undefined;
  const id = (parsed as { _id?: unknown })._id;
  if (typeof id !== "string" || id.trim() === "") return undefined;
  return `${CORRECTION_LOG_KEY_PREFIX}${id}`;
};
